import React from 'react';

interface Wholesale {
  wholesaleId?: string | null;
  pricelistWholesaleName?: string | null;
}

interface WholesaleNameHeaderCellsProps {
  wholesales: readonly (Wholesale | null | undefined)[] | null | undefined;
  rowSpan: number;
  loading?: boolean;
  /** 卸ごとのth keyを指定する。省略時はwholesaleIdをそのまま使う。 */
  getKey?: (wholesaleId: string | null | undefined, index: number) => string;
}

/**
 * 卸ごとの名称ヘッダー列(th)を描画する。
 * MedicineList/QuotationDetail/DraftQuotationで重複していた同一ロジックを共通化した。
 * PriceShowWholesaleHeadersは「安」マーク列や更新日時表示等を含む独自レイアウトのため対象外。
 */
export const WholesaleNameHeaderCells: React.FC<WholesaleNameHeaderCellsProps> = ({
  wholesales,
  rowSpan,
  loading,
  getKey,
}) => {
  if (loading || !wholesales || wholesales.length === 0) {
    return null;
  }

  return (
    <>
      {wholesales.map((wholesale, index) => {
        const key = getKey ? getKey(wholesale?.wholesaleId, index) : wholesale?.wholesaleId;
        return (
          <th key={key} rowSpan={rowSpan} className="align-middle">
            <div style={{ whiteSpace: 'pre' }}>{wholesale?.pricelistWholesaleName || ''}</div>
          </th>
        );
      })}
    </>
  );
};
